import util from "./_util";

const { request } = util;

export default {
  //用户登录/注册
  userLogin(data) {
    return request.post("/user/login", data);
  },
  //绑定手机号
  bindingMobile(data) {
    return request.post("/user/bind_mobile", data);
  },
  // 发送验证码
  SendCode(data) {
    console.log(data);
    return request.post("/user/send_validcode", data);
  },
  //党员注册
  partyRegister(data) {
    return request.post("/user/party_member_reg", data);
  },

  //查询用户个人中心（个人、党员、机构）
  queryMine(query) {
    return request.get("/user/get_user_index", query);
  },

  //保存用户信息
  saveUserInfo(data) {
    return request.post("/user/update", data);
  },

  //查询用户信息
  queryUserInfo(query) {
    return request.get("user/getinfo", query);
  },

  //登录单位账号
  organLogin(data) {
    return request.post("/user/login_organ", data);
  },
};
